// extracted by mini-css-extract-plugin
export default {"teams":"nationalTeams_teams__kT1xR","text":"nationalTeams_text__y7lti","tabs-container":"nationalTeams_tabs-container__AZ4GA"};